export const ROUTING_OPTIONS = {
    standard: {
        id: 1,
        name: 'Standard',
        tippyMessage: 'Standard routing option is unavailable when RTB is enabled in Reseller mode',
    },
    menu: {
        id: 2,
        name: 'Menu',
        tippyMessage: 'Menu option is unavailable when RTB is enabled',
    },
    ivr: {
        id: 3,
        name: 'Call Flow',
        tippyMessage: 'Call Flow option is unavailable when RTB is enabled',
    },
    revenue: {
        id: 4,
        name: 'Revenue',
    },
}
